'use client';

import { useState } from 'react';
import { CompletionStatus } from '@/types';

export const useCompletionStatus = () => {
    const [completionStatus, setCompletionStatus] = useState<CompletionStatus>(
        CompletionStatus.NONE,
    );

    const getCompletionStatus = async <T = unknown>(asyncfn: () => Promise<T>) => {
        try {
            setCompletionStatus(CompletionStatus.LOADING);
            const res = await asyncfn();
            setCompletionStatus(CompletionStatus.SUCCEEDED);
            return res;
        } catch (error) {
            setCompletionStatus(CompletionStatus.FAILED);
            throw error;
        }
    };

    const resetCompletionStatus = () => {
        setCompletionStatus(CompletionStatus.NONE);
    };

    return {
        getCompletionStatus,
        setCompletionStatus,
        resetCompletionStatus,
        completionStatus,
    };
};
